import { render } from "./JigsawContextMenu.vue?vue&type=template&id=3bbbdb86"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__